var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "6", md: 4, lg: 4, xl: 4 } },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.FormMSG(15, "Fuel type") } },
                [
                  _c("b-form-select", {
                    attrs: {
                      options: _vm.fuelTypeOptions,
                      placeholder: _vm.FormMSG(52, "Please select"),
                      disabled: _vm.disableAll,
                    },
                    on: { change: _vm.handleChangeFuelType },
                    model: {
                      value: _vm.dataToSend.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataToSend, "type", $$v)
                      },
                      expression: "dataToSend.type",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.hideQuantity
            ? _c(
                "b-col",
                { attrs: { sm: "6", md: "3", lg: "3", xl: "3" } },
                [
                  _vm.$screen.width > 576
                    ? _c(
                        "b-form-group",
                        { attrs: { label: _vm.FormMSG(16, "Quantity") } },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                class: {
                                  "bg-color-grams-hair": _vm.disableAll,
                                },
                                attrs: { disabled: _vm.disableAll },
                                on: { change: _vm.handleChangeQuantity },
                                model: {
                                  value: _vm.dataToSend.liter,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataToSend, "liter", $$v)
                                  },
                                  expression: "dataToSend.liter",
                                },
                              }),
                              _c(
                                "b-input-group-append",
                                [
                                  _c(
                                    "b-input-group-text",
                                    {
                                      staticClass:
                                        "bg-color-north-wind text-color-white",
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.FormMSG(17, "L")) +
                                          "\n\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "d-flex mt-3" }, [
                        _c(
                          "div",
                          { staticClass: "w-90 mr-3" },
                          [
                            _c(
                              "b-form-group",
                              { attrs: { label: _vm.FormMSG(16, "Quantity") } },
                              [
                                _c("b-form-input", {
                                  class: {
                                    "bg-color-grams-hair": _vm.disableAll,
                                  },
                                  attrs: { disabled: _vm.disableAll },
                                  on: { change: _vm.handleChangeQuantity },
                                  model: {
                                    value: _vm.dataToSend.liter,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataToSend, "liter", $$v)
                                    },
                                    expression: "dataToSend.liter",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center pt-3 text-capitalize",
                          },
                          [
                            _c("div", { staticClass: "fs-20 fw-700" }, [
                              _vm._v(_vm._s(_vm.FormMSG(17, "L"))),
                            ]),
                          ]
                        ),
                      ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }